var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#5F5F5F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -294,
    y: -385,
    width: 1440,
    height: 900,
    rx: 40,
    fill: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 78",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624516",
    x: -20,
    y: -281,
    width: 1115,
    height: 769,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2147223769"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2147223770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feedback-hand",
    clipPath: "url(#clip2_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 2.91667V4.08333C14 5.69158 12.6916 7 11.0833 7H9.91667C9.59467 7 9.33333 6.73867 9.33333 6.41667C9.33333 6.09467 9.59467 5.83333 9.91667 5.83333H11.0833C12.0482 5.83333 12.8333 5.04817 12.8333 4.08333V2.91667C12.8333 1.95183 12.0482 1.16667 11.0833 1.16667H2.91667C1.95183 1.16667 1.16667 1.95183 1.16667 2.91667V4.08333C1.16667 5.04817 1.95183 5.83333 2.91667 5.83333C3.23867 5.83333 3.5 6.09467 3.5 6.41667C3.5 6.73867 3.23867 7 2.91667 7C1.30842 7 0 5.69158 0 4.08333V2.91667C0 1.30842 1.30842 0 2.91667 0H11.0833C12.6916 0 14 1.30842 14 2.91667ZM10.9445 10.822L8.17075 9.78192V7.06242C8.17075 6.17808 7.54308 5.40925 6.71067 5.27392C6.19792 5.1905 5.67933 5.334 5.28792 5.66708C4.89592 6.00017 4.67133 6.48608 4.67133 7.00058V11.4123L4.08625 10.9462C3.38042 10.3145 2.2925 10.3594 1.64325 11.0548C0.984083 11.7594 1.02142 12.8689 1.71908 13.5223L2.04458 13.8361C2.15308 13.9411 2.29833 13.9994 2.44942 13.9994C2.97442 13.9994 3.23225 13.3607 2.85425 12.9961L2.52292 12.6764C2.28783 12.4559 2.27558 12.0855 2.49608 11.8504C2.71483 11.6159 3.08408 11.6048 3.31858 11.8224C3.325 11.8288 4.35167 12.6478 4.35167 12.6478C4.62933 12.8683 4.99975 12.9109 5.32 12.7563C5.63967 12.6023 5.83858 12.2862 5.83858 11.9309V6.99883C5.83858 6.82733 5.91325 6.66517 6.0445 6.55433C6.1775 6.44175 6.34725 6.39567 6.52458 6.42367C6.79408 6.468 7.00583 6.748 7.00583 7.06125V10.1844C7.00583 10.4277 7.15692 10.6453 7.38442 10.731L10.5367 11.9134C11.1848 12.1567 11.6293 12.7593 11.669 13.4493C11.6871 13.7597 11.9443 13.9988 12.2512 13.9988C12.2628 13.9988 12.2739 13.9988 12.2856 13.9983C12.607 13.9796 12.8526 13.7037 12.8339 13.3817C12.7668 12.2308 12.026 11.2257 10.9462 10.8208L10.9445 10.822ZM12.2319 3.1045C12.1899 2.98958 12.0802 2.91258 11.9578 2.91258H11.0828L10.773 2.04342C10.7304 1.92908 10.6213 1.85383 10.4994 1.85383C10.3775 1.85383 10.2684 1.92967 10.2258 2.04342L9.91608 2.91258H9.04108C8.91858 2.91258 8.8095 2.989 8.7675 3.10392C8.72492 3.21883 8.75933 3.34775 8.85267 3.4265L9.54625 3.99058L9.27208 4.87025C9.23533 4.98808 9.27617 5.117 9.37533 5.19108C9.42725 5.22958 9.4885 5.24942 9.55033 5.24942C9.60692 5.24942 9.6635 5.23308 9.7125 5.20042L10.5023 4.67192L11.3056 5.19517C11.4094 5.26225 11.5442 5.257 11.6427 5.18175C11.7407 5.10592 11.7804 4.97642 11.7413 4.85917L11.4561 3.99L12.1462 3.42767C12.2401 3.34892 12.2739 3.21942 12.2319 3.1045ZM8.73192 3.1045C8.68992 2.98958 8.58025 2.91258 8.45775 2.91258H7.58275L7.273 2.04342C7.23042 1.92908 7.12133 1.85383 6.99942 1.85383C6.8775 1.85383 6.76842 1.92967 6.72583 2.04342L6.41608 2.91258H5.54108C5.41858 2.91258 5.3095 2.989 5.2675 3.10392C5.22492 3.21883 5.25933 3.34775 5.35267 3.4265L6.19617 4.09267C6.42775 4.07458 6.66283 4.08333 6.89733 4.12183C7.37742 4.2 7.81667 4.40183 8.1865 4.69233L7.9555 3.98942L8.64558 3.42708C8.7395 3.34833 8.77392 3.21942 8.73192 3.1045ZM2.37475 5.19167C2.42667 5.23017 2.48792 5.25 2.54975 5.25C2.60633 5.25 2.66292 5.23367 2.71192 5.201L3.50175 4.6725L4.305 5.19575C4.40883 5.26283 4.54358 5.25758 4.64217 5.18233C4.74017 5.1065 4.77983 4.977 4.74075 4.85975L4.4555 3.99058L5.14558 3.42825C5.2395 3.3495 5.27392 3.22 5.23192 3.10508C5.18992 2.99017 5.08025 2.91317 4.95775 2.91317H4.08275L3.773 2.044C3.73042 1.92967 3.62133 1.85442 3.49942 1.85442C3.3775 1.85442 3.26842 1.93025 3.22583 2.044L2.91608 2.91317H2.04108C1.91858 2.91317 1.8095 2.98958 1.7675 3.1045C1.72492 3.21942 1.75933 3.34833 1.85267 3.42708L2.54625 3.99117L2.27208 4.87083C2.23533 4.98867 2.27558 5.11758 2.37475 5.19167Z",
    fill: "black"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -294,
    y: -385,
    width: 1440,
    height: 900,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1115,
    height: 769,
    fill: "white",
    transform: "translate(-20 -281)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.3a549209cd94b08baff5ed87a100f160.svg";
export { ForwardRef as ReactComponent };